enum TimesUsedUnit {
    Day = "Day",
    Week = "Week",
    Month = "Month"
}

export { TimesUsedUnit };
